// Copyright (c) billwerk GmbH. All rights reserved.
'use strict';

var OrdersController = function ($scope, $routeParams, Order, PUtill, OrdersDownloadByFilter, Features, gettext, DatepickerUtils) {
    $scope.status = '';
    $scope.type = '';

    $scope.statusName = PUtill.getText('Status');
    $scope.typeName = PUtill.getText('Type');

    $scope.dateRange = { dateFrom: null, dateTo: null };

    $scope.features = Features.features;

    $scope.isAvailableByFeature = function (featureName) {
        var value = $scope.features[featureName];
        return !!value;
    };

    $scope.updateFilter = function (func) {
        $scope.orders = $scope.paginator(function (options, callback) {
            return Order.query(options, function () {
                callback();
                if (func)
                    func();
                func = null;
            });
        }, getSearchParams(), 20);
    };

    var getSearchParams = function () {
        let searchParams = {
            search: $scope.search,
            dateFrom: $scope.dateRange.dateFrom,
            dateTo: PUtill.addDay($scope.dateRange.dateTo)
        };

        if ($scope.status)
            searchParams.status = $scope.status;
        
        if ($scope.type)
            searchParams.type = $scope.type;

        return searchParams;
    };

    function init() {
        if($routeParams.filter) {
            $scope.search = $routeParams.filter;
        }
        if (!$scope.search) {
            $scope.search = "";
        }
        $scope.updateFilter();
    }

    $scope.statusClass = function (status) {
        return PUtill.getStatusClass(status);
    };

    $scope.getCustomerName = function (order) {
        if (order.Contract.CustomerName) {
            return order.Contract.CustomerName;
        }
        var customer = order.Customer;
        if (customer) {
            if (customer.CompanyName)
                return customer.CompanyName;
            if (customer.FirstName) {
                if (customer.LastName)
                    return customer.LastName + ', ' + customer.FirstName;
                return customer.FirstName;
            }
            if (customer.LastName)
                return customer.LastName;
        }
        return "";
    };

    $scope.setStatus = function (status, defaultLabelName) {
        $scope.status = status.replace(' ', '');
        $scope.statusName = PUtill.getText(defaultLabelName || status);
        $scope.updateFilter();
    };

    $scope.setType = function (type, defaultLabelName) {
        $scope.type = type.replace(' ', '');
        $scope.typeName = PUtill.getText(defaultLabelName || type);
        $scope.updateFilter();
    };

    $scope.downloadByFilter = function () {
        var searchParams = getSearchParams();
        searchParams.isDownload = true;
        var download = function () {
            $scope.isL = true;
            var downloadInfo = new OrdersDownloadByFilter();
            downloadInfo.$save({
                isDownload: true,
                search: searchParams.search,
                dateFrom: searchParams.dateFrom,
                dateTo: searchParams.dateTo,
                status: searchParams.status,
                type: searchParams.type
            }, function () {
                window.location = downloadInfo.Url;
                $scope.isL = false;
            }, function () { $scope.isL = false; });
        };
        $scope.updateFilter(download);
    };

    gettext("ApprovalPending");

    init();

};
OrdersController.$inject = ['$scope', '$routeParams', 'Order', 'PUtill', 'OrdersDownloadByFilter', 'Features', 'gettext',
    'DatepickerUtils'];
